import React from 'react';
import { Container } from 'semantic-ui-react';
import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import { findError, validationClasses } from '@/utils/errors';
import fields from '@/constants/fields';
import ValidationSpan from '@/components/errors/ValidationSpan';
import MarkdownEditor from '@/components/text-editors/MarkdownEditor';
import HoverMarkdownContainer from '@/components/wrappers/HoverMarkdownContainer';
import { editRole, updateRoleProperties } from '../actions';

const RoleDescription = ({
  code,
  category,
  description,
  isEditing,
  canEdit,
  updateDescription,
  validationErrors,
  showEdit,
}) => {
  if (!canEdit && !description) {
    return null;
  }

  const validationError = findError(validationErrors, 'role', [fields.DESCRIPTION]);

  return (
    <Container fluid className="aridhia-role-description">
      <ValidationSpan validationError={validationError} />
      {!isEditing && (
      <HoverMarkdownContainer
        canEdit={canEdit}
        showEdit={() => showEdit(category, code)}
        value={description}
        editText="click.to.edit.description"
        position="top"
        toolTip="bottom right"
        editCopyMods="field-container"
        as="h2"
        className="aridhia-role-list-container aridhia-h3"
      />
      )}
      {canEdit && isEditing && (
      <MarkdownEditor
        id="role_description"
        value={description}
        onChange={(value) => updateDescription(code, category, { description: value })}
        maxEditorHeight={100}
        minPreviewHeight={90}
        className={validationClasses(validationError, 'aridhia-h3 aridhia-is-edit-mode ')}
      />
      )}
    </Container>
  );
};

const mapStateToProps = ({
  auth: { role: { permissions: { roles: { update } } } },
  roles: { roles },
}, { category, code }) => {
  const item = findResult(roles, category, code);
  const isEditing = item ? item.isEditing : false;
  const validationErrors = item ? item.updateErrors : null;

  return (
    {
      canEdit: update && !item.system,
      description: item ? item.description : '',
      isEditing,
      validationErrors,
    }
  );
};

const mapDispatchToProps = {
  updateDescription: updateRoleProperties,
  showEdit: editRole,
};

export default connect(mapStateToProps, mapDispatchToProps)(RoleDescription);
